import React, { useState } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import FormCaptchaField, {
  getFormField,
  submitToGoogleScript,
  useFormCaptcha,
} from './FormCaptcha'
import {
  REGISTER_FORM_URL,
  REGISTER_SUCCESS_MESSAGE,
  isFormScriptError,
} from '../config/formScripts'

export default function Register() {
  const [thankYouMessage, setThankYouMessage] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaError, setCaptchaError] = useState('');
  const captcha = useFormCaptcha();

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target;
    setSubmitError('');

    if (!captcha.validate()) {
      setCaptchaError('Please complete the CAPTCHA verification.');
      return;
    }
    setCaptchaError('');

    const url = REGISTER_FORM_URL

    setIsSubmitting(true);
    submitToGoogleScript(url, {
      FormType: 'register',
      Name: getFormField(form, 'name'),
      Number: getFormField(form, 'number'),
      Email: getFormField(form, 'email'),
      Phone: getFormField(form, 'phone'),
      Query: getFormField(form, 'query'),
    })
      .then((data) => {
        if (isFormScriptError(data)) {
          setSubmitError(data);
          return;
        }
        setThankYouMessage(data || REGISTER_SUCCESS_MESSAGE);
        setTimeout(() => setThankYouMessage(''), 5000);
        form.reset();
        captcha.reset();
      })
      .catch((error) => {
        setSubmitError('Something went wrong. Please try again.');
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <>
      <div className="main-wrapper page page-register">
        <Navbar />
        <div className="content-wrapper">
          <div className="about-us" data-aos="fade-up">
            <div className="about-us-title text-center">
              <div className="container">
                <h1 className="heading-bold text-uppercase">Registration</h1>
                <p className="page-hero-subtitle">
                  Connect with the LITAA North America Chapter
                </p>
              </div>
            </div>
          </div>

          <section className="register-page-section" data-aos="fade-up">
            <div className="container">
              <div className="register-card">
                <div className="register-card__header">
                  <h2>Join Our Community</h2>
                  <p>Fill in your details below and our team will get in touch.</p>
                  {thankYouMessage && (
                    <div className="thank-you-message register-thank-you">
                      {thankYouMessage}
                    </div>
                  )}
                  {submitError && (
                    <p className="form-captcha-error" role="alert">{submitError}</p>
                  )}
                </div>

                <form className="register-form" onSubmit={handleSubmit}>
                  <div className="register-form__field">
                    <label htmlFor="reg-name">Full Name</label>
                    <input id="reg-name" type="text" name="name" placeholder="Your full name" required />
                  </div>
                  <div className="register-form__field">
                    <label htmlFor="reg-batch">Batch Year</label>
                    <input id="reg-batch" type="text" name="number" placeholder="e.g. 1998" required />
                  </div>
                  <div className="register-form__field">
                    <label htmlFor="reg-email">Email Address</label>
                    <input id="reg-email" type="email" name="email" placeholder="you@email.com" required />
                  </div>
                  <div className="register-form__field">
                    <label htmlFor="reg-phone">Phone Number</label>
                    <input id="reg-phone" type="tel" name="phone" placeholder="+1 (555) 000-0000" required />
                  </div>
                  <div className="register-form__field">
                    <label htmlFor="reg-city">City / State</label>
                    <input id="reg-city" type="text" name="query" placeholder="City, State" required />
                  </div>
                  <FormCaptchaField
                    useRecaptcha={captcha.useRecaptcha}
                    mathChallenge={captcha.mathChallenge}
                    mathInput={captcha.mathInput}
                    onMathInputChange={captcha.setMathInput}
                    onRecaptchaChange={captcha.setRecaptchaToken}
                  />
                  {captchaError && (
                    <p className="form-captcha-error" role="alert">{captchaError}</p>
                  )}
                  <div className="register-form__actions">
                    <button
                      type="submit"
                      className="bnt bnt-theme register-submit-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Submitting...' : 'Register'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  )
}
